import type { SVGProps } from "react";
const SvgIconLookingGlass = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M783.53 748.17 597.2 561.84c33.55-41.33 53.66-94 53.66-151.38 0-132.77-107.63-240.4-240.4-240.4s-240.4 107.63-240.4 240.4 107.63 240.4 240.4 240.4c57.38 0 110.05-20.11 151.38-53.66l186.33 186.33c9.76 9.76 25.59 9.76 35.36 0s9.76-25.59 0-35.36M220.06 410.46c0-105.16 85.24-190.4 190.4-190.4s190.4 85.24 190.4 190.4-85.24 190.4-190.4 190.4-190.4-85.24-190.4-190.4" />
  </svg>
);
export default SvgIconLookingGlass;
